import { getUserFirstName } from "@faire/help-center-utils/serialized-data/getUser";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

export const HeaderTitle: React.FC = () => {
  const userFirstName = getUserFirstName();
  const { isMobile } = useViewport();
  return (
    <>
      {userFirstName ? (
        <Typography
          variant={isMobile ? "displaySSerifRegular" : "displayLSerifRegular"}
        >
          <StrictLocalMsg
            defaultMessage="Hi {userFirstNamePersonName}, how can we help?"
            description={{
              text: "Welcome message in the help center banner",
              img: "https://cdn.faire.com/fastly/d498b624bffa40b5c692e2ed97b5afd379deac1fc8ee290d3c3299096195ccc6.png",
            }}
            values={{
              userFirstNamePersonName: userFirstName,
            }}
          />
        </Typography>
      ) : (
        <Typography
          variant={isMobile ? "displaySSerifRegular" : "displayLSerifRegular"}
        >
          <StrictLocalMsg
            defaultMessage="How can we help?"
            description={{
              text: "Welcome header message in the help center banner",
              img: "https://cdn.faire.com/fastly/d498b624bffa40b5c692e2ed97b5afd379deac1fc8ee290d3c3299096195ccc6.png",
            }}
          />
        </Typography>
      )}
    </>
  );
};
